import { convertNum } from "./misc";

const perGameCalc = (val, playerGameCount) => {
  return convertNum(val) / convertNum(playerGameCount);
};

const getPerGameStatValue = (event, gameCount) => {
  if (!event || !event.target || !gameCount) return;
  const { value } = event.target;
  return perGameCalc(value, gameCount);
};

// Custom validation for teamGameCount
const validateTeamGameCount = (value, allValues) => {
  let sportCode = allValues.sportCode;
  if (sportCode === "boys-basketball" || sportCode === "girls-basketball") {
    sportCode = "basketball";
  }
  if (sportCode === "boys-soccer" || sportCode === "girls-soccer") {
    sportCode = "soccer";
  }
  if (sportCode === "girls-volleyball") {
    sportCode = "girlsvolleyball";
  }
  if (sportCode === "softball") {
    sportCode = "baseball";
  }
  const {
    [sportCode]: {
      seasonWins = 0,
      seasonLosses = 0,
      seasonTies = 0,
      homeWins = 0,
      homeLosses = 0,
      homeTies = 0,
      roadWins = 0,
      roadLosses = 0,
      roadTies = 0,
      teamGameCount = 0
    } = {}
  } = allValues;

  const totalGames1 =
    homeWins + homeLosses + homeTies + roadWins + roadLosses + roadTies;

  const totalGames2 = seasonWins + seasonLosses + seasonTies;

  if (teamGameCount !== totalGames1 || teamGameCount !== totalGames2) {
    return `Team game count must match home/away (${totalGames1}) and season total (${totalGames2}).`;
  }
  return undefined;
};

const mustBePositive = (value) =>
  value < 0 ? "Must be a positive number" : undefined;

const mustBeInteger = (value) =>
  value && !Number.isInteger(value) ? "Must be an integer" : undefined;

export {
  perGameCalc,
  getPerGameStatValue,
  validateTeamGameCount,
  mustBeInteger,
  mustBePositive
};
